import { ProjectTag, ProjectTagDTO } from 'model';
import { createFeatureThunks } from '../../../redux/featureThunks';

export const projectTagThunk = createFeatureThunks<ProjectTag, ProjectTagDTO>({
  urlFactory: ({ id } = { id: undefined }) =>
    `/projects/project-tag${id !== undefined ? `/${id}` : ''}`,
  thunkName: 'project-tag'
});
